import { DossierSettings, SectionName, useGetDossierSettings } from "@/entities/dossier-settings";
import { MessageBar } from "@/shared/components";
import { useSectionsStore } from "../../stores/sections.store";

const defaultSections: SectionName[] = [
    "DossierDetails",
    "VsmOfOpstartplan",
    "Tvv",
    "Faciliteiten",
    "BetrokkenTreinen",
    "MedewerkersOpStation",
    "Evaluatie",
];

type CustomSectionsNotificationProps = {
    dossierId: string;
    onEditSections: () => void;
};

export function CustomSectionsNotification({ dossierId, onEditSections }: CustomSectionsNotificationProps) {
    const dismissedSections = useSectionsStore((state) => state.dismissedSections);
    const dismissSection = useSectionsStore((state) => state.dismissSection);

    const { data: dossierSettings, isPending, error } = useGetDossierSettings(dossierId);

    if (isPending || error) return null;

    const customSections = DossierSettings.areSectionNamesDifferent(
        DossierSettings.getEnabledSectionNames(dossierSettings),
        defaultSections
    );

    if (!customSections || dismissedSections.includes(dossierId)) return null;

    return (
        <MessageBar variant="info" className="flex items-center" onClose={() => dismissSection(dossierId)}>
            Dit dossier toont andere secties dan een standaard dossier.{" "}
            <button className="text-content-info cursor-pointer underline" onClick={onEditSections}>
                Secties instellen
            </button>
        </MessageBar>
    );
}
